export { default as fetchStaticParams } from './fetchStaticParams';
export { default as fetchAndUseI18n } from './fetchAndUseI18n';
export { default as fetchMetadata } from './fetchMetadata';
export { default as fetchTaxonomyCounts } from './fetchTaxonomyCounts';
export { default as fetchSpecialPages } from './fetchSpecialPages';
export { default as fetchTotalCount } from './fetchTotalCount';
